import { useNavigate } from 'react-router-dom';
import type { SentMessageEntry } from '@/mocks/listenerCenter';

interface Props {
  messages: SentMessageEntry[];
}

export default function SentMessages({ messages }: Props) {
  const navigate = useNavigate();
  const slug = (name: string) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const statusColors: Record<string, string> = {
    'Leído al aire': 'bg-emerald-100 text-emerald-700',
    'Pendiente': 'bg-amber-100 text-amber-700',
    'Favorito': 'bg-rose-100 text-rose-700',
    'Archivado': 'bg-foreground-100 text-foreground-600',
  };

  const typeIcons: Record<string, string> = {
    'Saludo': 'ri-hand-heart-line',
    'Solicitud de canción': 'ri-music-line',
    'Petición': 'ri-chat-3-line',
    'Concurso': 'ri-trophy-line',
  };

  const formatTime = (iso: string) => {
    const d = new Date(iso);
    const now = new Date();
    const diffHrs = Math.floor((now.getTime() - d.getTime()) / 3600000);
    if (diffHrs < 1) return 'Ahora';
    if (diffHrs < 24) return `Hace ${diffHrs}h`;
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground-950">Mensajes Enviados ({messages.length})</h3>
      </div>
      <div className="space-y-3">
        {messages.map((msg) => (
          <div key={msg.id} className="bg-background-50 rounded-xl p-4">
            <div className="flex items-start gap-3 mb-2">
              <img
                src={msg.stationLogo}
                alt={msg.stationName}
                className="w-10 h-10 rounded-xl object-cover object-top shrink-0 cursor-pointer"
                onClick={() => navigate(`/radio/${slug(msg.stationName)}`)}
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span
                    className="text-sm font-semibold text-foreground-950 cursor-pointer hover:text-primary-600 transition-colors"
                    onClick={() => navigate(`/radio/${slug(msg.stationName)}`)}
                  >
                    {msg.stationName}
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${statusColors[msg.status] || 'bg-foreground-100 text-foreground-600'}`}>
                    {msg.status}
                  </span>
                </div>
                <div className="flex items-center gap-1.5 text-[10px] text-foreground-400 mb-2">
                  <i className={`${typeIcons[msg.type] || 'ri-chat-3-line'}`}></i>
                  <span>{msg.type}</span>
                  <span className="w-1 h-1 bg-foreground-300 rounded-full"></span>
                  <span>{formatTime(msg.sentAt)}</span>
                </div>
                <p className="text-sm text-foreground-700 bg-background-100 rounded-lg p-3 italic">
                  "{msg.message}"
                </p>
                {msg.reply && (
                  <div className="mt-2 pl-3 border-l-2 border-primary-300">
                    <p className="text-xs text-foreground-500">Respuesta del locutor:</p>
                    <p className="text-sm text-primary-700 font-medium mt-0.5">{msg.reply}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}